import _ from 'lodash';
import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';
import ModelDataSourcePropertyStatic from "./ModelDataSourcePropertyStatic";
import ModelDataSourcePropertyTable from "./ModelDataSourcePropertyTable";
import ModelDataSourcePropertyJavascript from "./ModelDataSourcePropertyJavascript";
import ModelDataSourcePropertyScriptService from "./ModelDataSourcePropertyScriptService";
import ModelDataSourceDataPreviewProperty from "./ModelDataSourceDataPreviewProperty";
import ModelDataSourcePropertyService from "./ModelDataSourcePropertyService";
import ModelDataSourcePropertyServiceBeijingAQI from "./ModelDataSourcePropertyServiceBeijingAQI";
import ModelDataSourcePropertyServiceRainfall from "./ModelDataSourcePropertyServiceRainfall";
import ModelDataSourcePropertyServiceTemperature from "./ModelDataSourcePropertyServiceTemperature";
import ModelDataSourcePropertyServiceHeightWeight from "./ModelDataSourcePropertyServiceHeightWeight";
import ModelDataSourcePropertyServiceRandomUser from "./ModelDataSourcePropertyServiceRandomUser";
import ModelDataSourcePropertyServiceMapUSA from "./ModelDataSourcePropertyServiceMapUSA";
import ModelDataSourcePropertyServiceMapChina from "./ModelDataSourcePropertyServiceMapChina";
import ModelDataSourcePropertyServiceMapChinaLocation from "./ModelDataSourcePropertyServiceMapChinaLocation";

import ModelActionProperty from "./properties/ModelActionProperty";

export default class Model extends ObservablePropertyDescriptorObject {

    type = new PropertyDescriptor('none', '类型', "基本", "enum", "#anticon-INGRESS-GLYPH-CREATE-", {
        values: [
            new PropertyDescriptor("none", "无", "", "string", "#anticon-no-data"),
            new PropertyDescriptor("table", "数据表", "", "string", "#anticon-charubiaoge1"),
            new PropertyDescriptor("script-service", "脚本服务", "", "string", "#anticon-ziyuan1"),
            new PropertyDescriptor("service", "网络服务", "", "string", "#anticon-link"),
            new PropertyDescriptor("static", "静态数据", "", "string", "#anticon-JSON-copy"),
            new PropertyDescriptor("javascript", "脚本", "", "string", "#anticon-Documentation"),
            new PropertyDescriptor("service-sample-AQI", "示例数据 - 空气质量", "", "string", "#anticon-link"),
            new PropertyDescriptor("service-sample-Rainfall", "示例数据 - 降雨量", "", "string", "#anticon-link"),
            new PropertyDescriptor("service-sample-Temperature", "示例数据 - 温度", "", "string", "#anticon-link"),
            new PropertyDescriptor("service-sample-HeightWeight", "示例数据 - 身高体重", "", "string", "#anticon-link"),
            new PropertyDescriptor("service-sample-RandomUser", "示例数据 - 随机用户", "", "string", "#anticon-link"),
            new PropertyDescriptor("service-sample-MapUSA", "示例数据 - 美国地图", "", "string", "#anticon-link"),
            new PropertyDescriptor("service-sample-MapChina", "示例数据 - 中国地图", "", "string", "#anticon-link"),
            new PropertyDescriptor("service-sample-MapChinaLocation", "示例数据 - 中国地图位置", "", "string", "#anticon-link"),
        ],
    });

    name = new PropertyDescriptor("", '名称', "基本", "string", "#anticon-ui-text-field-format", {
        description: "给数据源取一个名称，以方便在其他地方通过名称使用数据源",
        visible: false,
    });

    isDefault = new PropertyDescriptor(false, '默认数据源', "其他", "bool", "#anticon-profile-setting", {
        enabled: false,
    });

    settings = new PropertyDescriptor(new ModelDataSourcePropertyStatic(), '参数', "高级", "propertygrid", "#anticon-profile-setting", {
        visible: false,
    });

    // flag = new PropertyDescriptor(0.0, '加载标识', "其他", "double", "#anticon-profile-setting", {
    //     enabled: false,
    // });

    data = new PropertyDescriptor(null, '数据', "其他", "object", "#anticon-profile-setting", {
        enabled: false,
    });

    dataPreview = new PropertyDescriptor(new ModelDataSourceDataPreviewProperty(), '预览', "预览", "propertygrid", "#anticon-xianshiqilan", {
        visible: false,
        valueTemplate: ModelDataSourceDataPreviewProperty,
    });

    actionsBeforeLoad = new PropertyDescriptor([], '加载前', "动作", "objects", "#anticon-shuaxin", {
        // visible: false,
        description: "数据加载前，需要执行的动作。当有多个动作时，将从上到下依次执行",
        modelTemplate: ModelActionProperty,
        modelGetter: (opts) => {
            const m = new ModelActionProperty(opts);
            // m._sys.__runScript = this._sys.ui && this._sys.ui.runScript.bind(this._sys.ui);
            return m;
        },
    });

    actions = new PropertyDescriptor([], '数据改变后', "动作", "objects", "#anticon-GroupCopy", {
        // visible: false,
        description: "数据源第一次加载和后续的刷新都会触发数据改变。这里可配置数据改变后，需要执行的动作。当有多个动作时，将从上到下依次执行",
        modelTemplate: ModelActionProperty,
        modelGetter: (opts) => {
            const m = new ModelActionProperty(opts);
            // m._sys.__runScript = this._sys.ui && this._sys.ui.runScript.bind(this._sys.ui);
            return m;
        },
    });

    actionsError = new PropertyDescriptor([], '报错后', "动作", "objects", "#anticon-Exceptionlabel_white", {
        // visible: false,
        description: "数据源加载过程发生错误后，需要执行的动作。当有多个动作时，将从上到下依次执行",
        modelTemplate: ModelActionProperty,
        modelGetter: (opts) => {
            const m = new ModelActionProperty(opts);
            // m._sys.__runScript = this._sys.ui && this._sys.ui.runScript.bind(this._sys.ui);
            return m;
        },
    });

    manualDataSource = new PropertyDescriptor(false, '手动数据源', "其他", "bool", "#anticon-SystemManagement", {
        description: "启用后，该数据源只会在点击刷新按钮或动作触发数据源刷新时才会加载数据"
    });

    pureDataSource = new PropertyDescriptor(false, '界面无感知', "其他", "bool", "#anticon-eye2", {
        description: "开启后该数据源专用于加载数据，而不会导致界面重绘。数据源中的动作仍旧会正常执行，不受影响"
    });

    constructor(opts = {}) {
        super();

        this.defineAllProperties();
        this._sys.debounceLoadData = _.debounce((e) => { this.innerRefresh(e) }, 200);

        for (var p in opts) {
            if (p !== "settings")
                this[p] = opts[p];
        }

        this.settings = this.createArgs(this.type, opts.settings);
    }

    createArgs(type, opts) {

        if (type === "static") {
            return new ModelDataSourcePropertyStatic(opts);
        }

        else if (type === "table") {
            return new ModelDataSourcePropertyTable(opts);
        }

        else if (type === "javascript") {
            return new ModelDataSourcePropertyJavascript(opts);
        }

        else if (type === "script-service") {
            return new ModelDataSourcePropertyScriptService(opts);
        }

        else if (type === "service") {
            return new ModelDataSourcePropertyService(opts);
        }

        else if (type === "service-sample-AQI") {
            return new ModelDataSourcePropertyServiceBeijingAQI(opts);
        }

        else if (type === "service-sample-Rainfall") {
            return new ModelDataSourcePropertyServiceRainfall(opts);
        }

        else if (type === "service-sample-Temperature") {
            return new ModelDataSourcePropertyServiceTemperature(opts);
        }

        else if (type === "service-sample-HeightWeight") {
            return new ModelDataSourcePropertyServiceHeightWeight(opts);
        }

        else if (type === "service-sample-RandomUser") {
            return new ModelDataSourcePropertyServiceRandomUser(opts);
        }

        else if (type === "service-sample-MapUSA") {
            return new ModelDataSourcePropertyServiceMapUSA(opts);
        }

        else if (type === "service-sample-MapChina") {
            return new ModelDataSourcePropertyServiceMapChina(opts);
        }

        else if (type === "service-sample-MapChinaLocation") {
            return new ModelDataSourcePropertyServiceMapChinaLocation(opts);
        }

        else
            return null;
    }

    refresh(data) {
        if (!this._sys.__uiReady)
            return;

        this._sys.debounceLoadData(data);
    }

    refreshInner(data) {
        if (this.manualDataSource)
            return;

        this.refresh(data);
    }

    onPropertyValueChanged(name, valOld, valNew, subName, args) {

        // console.log(name, valNew);

        if (this.pureDataSource)
            args.handled = true;

        if (name.startsWith("dataPreview") && name !== "dataPreview.data.isBusy")
            args.handled = true;

        if (name === "type") {
            if (!this._sys._backup)
                this._sys._backup = {};

            this._sys._backup[valOld] = this.settings && this.settings.toJsonObject();
            this.settings = this.createArgs(valNew, this._sys._backup[valNew]);
            this.setPropertyVisible("settings", valNew !== "none");
            this.setPropertyVisible("name", valNew !== "none");
            this.setPropertyVisible("dataPreview", valNew !== "none");
            // this.setPropertyVisible("actions", valNew !== "none");
        }

        else if (name.startsWith("settings.") || name === "settings")
            this.refreshInner();

        // else if (name === "flag")
        //     this._sys.debounceLoadData();

        else if (name === "dataPreview.data.flag") {
            this.refresh();
        }

        else if (name === "data")
            this._sys.__runActions && this._sys.__runActions(this.actions, valNew);
    }

    load(e) {
        return new Promise((resolve, reject) => {
            if (!this._sys.__uiReady) {
                reject(new Error("控件还未初始化"));
                return;
            }

            if (!this.settings) {
                this.data = null;
                this.dataPreview.data = {};
                resolve(null);
                return;
            }

            const preValue = this._sys.__runActions && this._sys.__runActions(this.actionsBeforeLoad, e);
            if (preValue === false) {
                reject(false);
                return;
            }

            this.dataPreview.data.isBusy = true;

            this.settings.loadData({
                runScript: this._sys.__runScript,
                data: e,
                lastData: this.data,

            }).then(data => {
                data = data || { result: null, columns: [] };
                this.dataPreview.data = { data: data.result, columns: data.columns, isBusy: true };
                this.dataPreview.data.isBusy = false;
                this.data = data.result;
                resolve(this.data, data);

            }).catch(err => {
                if (err && err.message)
                    err = err.message;

                this._sys.__runActions && this._sys.__runActions(this.actionsError, {
                    data: e,
                    error: err,
                });

                this.dataPreview.data = { error: err, isBusy: true };
                this.dataPreview.data.isBusy = false;
                console.error(err);

                reject(err);
            });
        });
    }

    innerRefresh(e) {
        // if (!this._sys.__runScript)
        if (!this._sys.__uiReady)
            return;

        if (!this.settings) {
            this.data = null;
            this.dataPreview.data = {};
            return;
        }

        const preValue = this._sys.__runActions && this._sys.__runActions(this.actionsBeforeLoad, e);
        if (preValue === false) {
            return;
        }

        this.dataPreview.data.isBusy = true;

        this.settings.loadData({
            runScript: this._sys.__runScript,
            data: e,
            lastData: this.data,

        }).then(data => {
            data = data || { result: null, columns: [] };
            this.dataPreview.data = { data: data.result, columns: data.columns, isBusy: true };
            this.dataPreview.data.isBusy = false;
            this.data = data.result;

        }).catch(err => {
            if (err && err.message)
                err = err.message;

            this._sys.__runActions && this._sys.__runActions(this.actionsError, {
                data: e,
                error: err,
            });

            this.dataPreview.data = { error: err, isBusy: true };
            this.dataPreview.data.isBusy = false;
            console.error(err);
        });
    }

    toJsonObject() {

        let o = super.toJsonObject();
        // delete o.flag;
        delete o.data;
        delete o.dataPreview;

        return o;
    }

    toString() {
        return {
            svg: `${this._.type._sys.__mapValues[this.type].svg}`,
            text: `${this._.type._sys.__mapValues[this.type].alias}${this.name ? " - " + this.name : ""}`
        };
    }
}
